module.exports = __webpack_public_path__ + "assets/img/pro_2.e5e01098.png";